import React from 'react';
import { getUrlParam, isDevEnv, isTestEnv, isProductionEnv, isPrereleaseEnv } from 'utils/common';

/**
 * Heap Analytics Loader
 * Usage after loaded:
 *   window.heap.track('EventName', { prop: 'value' })
 *   window.heap.addUserProperties({ userId: '123' })
 */
const HeapAnalytics: React.FC = () => {
    React.useEffect(() => {
        let heapAppId: number | undefined;
        if (isProductionEnv() || isPrereleaseEnv()) {
            heapAppId = 1059864034; // prod id (match helloklarity live/prerelease)
        } else if (isTestEnv()) {
            heapAppId = 489926294; // use dev id on test if needed
        } else if (isDevEnv()) {
            heapAppId = 489926294; // dev id
        } else {
            heapAppId = 489926294; // fallback to dev id
        }

        if (!heapAppId) return;

        // do not double-insert
        if (document.getElementById('heap-analytics-script')) {
            return;
        }

        (window as any).heap = (window as any).heap || [];
        (window as any).heap.load = function load(e: string, t?: Record<string, any>) {
            (window as any).heap.appid = e;
            (window as any).heap.config = t = t || {};
            const r = document.createElement('script');
            r.type = 'text/javascript';
            r.async = true as any;
            r.src = `https://cdn.heapanalytics.com/js/heap-${e}.js`;
            r.id = 'heap-analytics-script';
            const a = document.getElementsByTagName('script')[0];
            a.parentNode?.insertBefore(r, a);
            const n = function (method: string) {
                return function () {
                    (window as any).heap.push([method].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            const methods = [
                'addEventProperties',
                'addUserProperties',
                'clearEventProperties',
                'identify',
                'resetIdentity',
                'removeEventProperty',
                'setEventProperties',
                'track',
                'unsetEventProperty',
            ];
            for (let o = 0; o < methods.length; o += 1) {
                (window as any).heap[methods[o]] = n(methods[o]);
            }
        };
        (window as any).heap.load(`${heapAppId}`);

        // set tracking cookies if present
        const gclid = getUrlParam('gclid');
        if (gclid) {
            document.cookie = `GCLID=${encodeURIComponent(gclid)}; path=/; max-age=${30 * 24 * 60 * 60}`;
        }
        const fbclid = getUrlParam('fbclid');
        if (fbclid) {
            document.cookie = `FBCLID=${encodeURIComponent(fbclid)}; path=/; max-age=${30 * 24 * 60 * 60}`;
        }
    }, []);

    return null;
};

export default HeapAnalytics;
